export default {
  data () {
    return {}
  },
  watch: {},
  created () {
    // const ou = this.$urlParam?.ou;
    console.warn('App handleQuery.mixin.js')

    const {
      ou = '', // originOurl
      sysId = 'A001'
    } = this.$route.query

    this.$vuex('vuex_sysId', sysId)

    // if (this.vuex_isp_app_token) {
    //   this.$myToast({
    //   type: "success",
    //   message: `已登录`,
    // });
    // }

    // if (ou) {
    //     console.log("有ou");
    //     //originOurl
    //     // console.log("aaa");
    //     this.$router.push({
    //         path: "/" + ou,
    //         query: {
    //             ...this.$route.query,
    //             ou: undefined,
    //             ouq: undefined,
    //             ...(this.$route.query.ouq || {}),
    //         },
    //     });
    // } else {
    //     console.log("没有ou");
    //     const clearPageList = ["login"];
    //     clearPageList.forEach((path) => {
    //         localStorage.removeItem(`${path}_saveData`);
    //     });
    //     console.log("ou clearPageList end");
    // }
  },
  methods: {}
}
